import { h } from 'preact';

const Caret = () => (
	<svg
		width={18}
		height={11}
		viewBox="0 0 18 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1970_25331)">
			<path
				d="M17.68 2.662L14.97.268l-5.975 5.28L3.02.267.31 2.662l8.685 7.674 8.685-7.674z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1970_25331">
				<path
					fill="#fff"
					transform="rotate(90 8.706 8.974)"
					d="M0 0H10.0685V17.3694H0z"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default Caret;
